<template>
    <div class="form-field form-field__input form-field__select" :class="rootClasses">
        <label class="form-field--title-label"
                v-if="label"
                :for="id"
                v-html="label"/>
        <div class="form-field--input-container" :data-action-count="1">
            <select class="form-field--input"
                    v-if="isMounted"
                    ref="input"
                    v-bind="inputAttrs"
                    v-model="model"
                    @focus="onFocus"
                    @blur="onBlur">
                <option value
                        disabled
                        v-if="placeholder"
                        :selected="!value"
                        v-text="placeholder"/>
                <option v-for="item in uniqueItems"
                        :key="item.id"
                        :value="item.val"
                        v-html="item.label || item.val"/>
            </select>
            <div class="form-field--actions">
                <span class="form-field--action form-field--action__arrow">
                    <base-icon v-bind="icon"/>
                </span>
            </div>
        </div>
        <form-field-messages
                :messages="messages"
                :active-item="activeItem"/>
    </div>
</template>

<script>
    import FormFieldMessages from 'framework/components/form//form-field-messages/form-field-messages';
    import formFieldAbstractMixin from 'framework/mixins/form/form-field-abstract';
    import formFieldItemsMixin from 'framework/mixins/form/form-field-items';


    export default {
        components: {
            FormFieldMessages,
        },
        mixins: [
            formFieldAbstractMixin,
            formFieldItemsMixin,
        ],
        props: {
            value: {
                type: [Number, String],
                required: true,
            },
            items: {
                type: Array,
                required: true,
            },
            icon: {
                type: Object,
                default() {
                    return {
                        symbol: 'chevron-down',
                        size: 'medium',
                    };
                },
            },
        },
        computed: {
            specificRootClasses() {
                return [
                    this.bemIf(this.hasFocus, 'has-focus'),
                ];
            },
        },
    };
</script>
